import { Button } from '@/components/Elements';
import { useTranslation } from 'react-i18next';
import { ChevronDoubleRightIcon } from '@heroicons/react/24/outline';
import { TagViewDialog } from '@/features/connect-dots/pages/TagViewDialog';
import { useTagViewDialog } from '../hooks/useTagViewDialog';

interface OpenTagViewButtonProps {
  className?: string;
}

export const OpenTagViewButton = ({ className }: OpenTagViewButtonProps) => {
  const { t } = useTranslation();
  const { isOpen, open: openTagView, close: closeTagView } = useTagViewDialog();

  const openTagViewDialog = () => {
    openTagView();
  };

  const closeTagViewDialog = () => {
    closeTagView();
  };

  return (
    <>
      <Button
        className={className}
        onClick={openTagViewDialog}
        color="secondary"
        size="xs"
      >
        <div className="flex items-center">
          {t('Open TagView')}
          <ChevronDoubleRightIcon className="size-3" />
        </div>
      </Button>

      {/* TagViewDialogを表示 */}
      <TagViewDialog isOpen={isOpen} onClose={closeTagViewDialog} />
    </>
  );
};
